// 路由配置

export default [
  {
    name: 'Home',
    path: '/home', // 根路径首页，所有项目共用
    component: () => import ("@/views/Home"),
    meta: {
      showHeader: false,
      showFooter: false
    }
  },
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/404',
    component: () => import('@/components/404'),
  },
  /*
   * 表单路由
   */
  {
    name: 'Form',
    path: '/form', // 根路径首页，所有项目共用
    component: () => import ("@/views/Form"),
    meta: {
      showHeader: false,
      showFooter: false
    }
  },
  {
    name: 'MForm',
    path: '/m/form', // 根路径首页，所有项目共用
    component: () => import ("@/views/Form"),
    meta: {
      showHeader: false,
      showFooter: false
    }
  },
  /*
   * 直播功能路由开始
   */
  {
    name: 'BroadcastList', // 直播功能模块列表页
    path: '/broadcast/list/:id',
    component: () => import(/* webpackChunkName: "s" */ '@/views/Broadcast/List'),
    meta: {
      showHeader: false,
      showFooter: false
    }
  },
  {
    name: 'BroadcastDetail', // 直播功能模块详情页
    path: '/broadcast/detail/:id',
    component: () => import(/* webpackChunkName: "s" */ '@/views/Broadcast/Detail'),
    meta: {
      showHeader: false,
      showFooter: false
    },
  },
  {
    name: 'MBroadcast', // 直播功能移动首页
    path: '/m/broadcast/index',
    component: () => import(/* webpackChunkName: "s" */ '@/views/Broadcast/Mobile/index'),
  },
  {
    name: 'MBroadcastlist', // 直播功能移动列表页
    path: '/m/broadcast/list/:id',
    component: () => import(/* webpackChunkName: "s" */ '@/views/Broadcast/Mobile/list'),
  },
  {
    name: 'MBroadcastdetail', // 直播功能移动详情页
    path: '/m/broadcast/detail/:id',
    component: () => import(/* webpackChunkName: "s" */ '@/views/Broadcast/Mobile/detail'),
  },

  /*
   * AI机器人功能路由开始
   */
  {
    name: 'Robot',
    path: '/robot/:id',
    component: () => import(/* webpackChunkName: "s" */ '@/views/Robot/index'),
    meta: {
      showHeader: false,
      showFooter: false
    }
  },
  {
    name: 'MRobot',
    path: '/m/robot/:id',
    component: () => import(/* webpackChunkName: "s" */ '@/views/Robot/index'),
    meta: {
      showHeader: false,
      showFooter: false
    }
  },
  {
    name: 'VoiceCall',
    path: '/m/robot/voicecall/:id',
    component: () => import(/* webpackChunkName: "s" */ '@/views/Robot/voiceCall'),
    meta: {
      showHeader: false,
      showFooter: false
    }
  },

  /*
   * 路由错误处理
   */
  {
    path: '*',
    redirect: '/404'
  }
]
